import React from 'react';

import {
  createCouncilDecision,
  getCouncilDecisionById,
  updateCouncilDecision,
} from '../../../../services/taxonomies/council-decision';
import { useEditPage } from '../../../../hooks/useEditPage';
import { Default } from '../../../../layouts';
import EditCouncilDecisionForm from '../../../../components/council-decisions/EditCouncilDecisionForm';

const initialCouncilDecision = {
  deleted: false,
};

const EditCouncilDecision = () => {
  const [councilDecision, handleSubmit, handleCancel] = useEditPage({
    initial: initialCouncilDecision,
    existent: getCouncilDecisionById,
    goBackPath: '/admin/taxonomies/council-decisions',
    onCreate: createCouncilDecision,
    onUpdate: updateCouncilDecision,
  });

  return (
    <Default>
      {councilDecision !== undefined && (
        <EditCouncilDecisionForm
          councilDecision={councilDecision}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}
    </Default>
  );
};

export default EditCouncilDecision;
